import { ref, set, update } from 'firebase/database';
import { logEvent } from 'firebase/analytics';
import { database, analytics } from '../firebase';

// Generate a unique session ID
const generateSessionId = () => {
  return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

// Keep the session ID for the current user
const sessionId = generateSessionId();

// Service to handle ROI calculator statistics
export const saveROIStatistics = async (stats) => {
  try {
    // Create a reference to this specific user's session in the database
    const statsRef = ref(database, `roi-statistics/${sessionId}`);
    
    // Update the statistics for this session
    await set(statsRef, {
      ...stats,
      lastUpdate: new Date().toISOString(),
      sessionStarted: stats.timestamp
    });

    // Log event to Analytics
    logEvent(analytics, 'roi_calculator_interaction', {
      action: stats.action,
      beansPerWeek: stats.inputs.beansPerWeek,
      pacoteSoldPerWeek: stats.inputs.pacoteSoldPerWeek,
      totalReturnOnInv: stats.calculations.totalReturnOnInv,
      precoRoastedPerKg: stats.inputs.precoRoastedPerKg,
      precoGreenPerKg: stats.inputs.precoGreenPerKg
    });
    
    return { success: true, sessionId };
  } catch (error) {
    console.error('Error saving ROI statistics:', error);
    // Optionally rethrow or handle error
  }
};

// Link form submission with ROI session
export const linkFormSubmission = async (respondentId, formInfo) => {
  try {
    if (!sessionId) return; // No ROI session to link to
    
    const statsRef = ref(database, `roi-statistics/${sessionId}`);
    await update(statsRef, {
      formSubmissionId: respondentId,
      formId: formInfo.formId,
      formSubmittedAt: formInfo.createdAt,
      lead: {
        companyName: formInfo.companyName,
        contactName: formInfo.contactName,
        businessType: formInfo.businessType,
        alreadyRoasting: formInfo.alreadyRoasting,
        contactPreference: formInfo.contactPreference,
        whatsapp: formInfo.whatsapp,
        email: formInfo.email,
        wantsPilot: formInfo.wantsPilot
      }
    });
    
    // Log event to Analytics with more details
    logEvent(analytics, 'roi_form_submission_linked', {
      sessionId,
      formId: formInfo.formId,
      companyName: formInfo.companyName,
      businessType: formInfo.businessType,
      alreadyRoasting: formInfo.alreadyRoasting,
      wantsPilot: formInfo.wantsPilot
    });
    
    return { success: true };
  } catch (error) {
    console.error('Error linking form submission:', error);
  }
}; 